/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAssessmentRunTtlRefresh extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAssessmentRunTtlRefresh");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAssessmentRunTtlRefresh.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAssessmentRunTtlRefresh>): BackgroundJobPayloadForAssessmentRunTtlRefresh {
        let obj = Object.assign(new BackgroundJobPayloadForAssessmentRunTtlRefresh(), model);
        BackgroundJobPayloadForAssessmentRunTtlRefresh.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAssessmentRunTtlRefresh>): BackgroundJobPayloadForAssessmentRunTtlRefresh {
        if (!model) return null;
        return BackgroundJobPayloadForAssessmentRunTtlRefresh.newInstance(<BackgroundJobPayloadForAssessmentRunTtlRefresh> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAssessmentRunTtlRefresh) {
        if (!obj) return;

        models.BackgroundJobPayloadForAssessmentRunTtlRefresh.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAssessmentRunTtlRefresh): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAssessmentRunTtlRefresh.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.refresh_data_list) {
            for (let val of this.refresh_data_list) {
                models.WellArchitectedFrameworkAssessmentRunTTLRefreshRequest.fixupPrototype(val);
            }
        }
    }

    refresh_data_list: Array<models.WellArchitectedFrameworkAssessmentRunTTLRefreshRequest>;

}
